import { NextPageContextEnhanced } from "../../types/page";
import { CookiesConstants } from "utils/constants";
import { IMember } from "../../screens/AccountMembership/_private/types/midView";
import isDeviceMobile from "utils/misc/isDeviceMobile";
import {setCookie} from "utils/nookies";
import { jsonSafeGet } from "utils/Helpers";
import {
  AuthTicketType, AuthV2Type,
  FIELDS_USER_INFO,
  LiteUserInfo,
  minimizeUserInfoFields
} from "dataLayer/localStorage/localStorageMember";


export function applyCookies(context: NextPageContextEnhanced) {
  let userInfo = jsonSafeGet<LiteUserInfo>(context.cookies?.[CookiesConstants.USER_INFO]) || {};
  if(typeof userInfo !=='object') {
    userInfo = {};
  }
  const isHeavyCookie = Object.keys(userInfo)?.length > FIELDS_USER_INFO.length;

  if(isHeavyCookie) {
    userInfo = minimizeUserInfoFields(userInfo);
    setCookie(context, CookiesConstants.USER_INFO, JSON.stringify(userInfo));
  }

  context.setData("member_id", Number(userInfo?.["id"]) || null);
  context.memberData = (
    context.getData("member_id") ? userInfo : {}
  ) as LiteUserInfo;
  context.setData(
      "tgtTimestamp",
      ((jsonSafeGet<AuthTicketType>(context.cookies[CookiesConstants.AUTH_V2])?.t || context.cookies[CookiesConstants.TGT_TIMESTAMP]) &&
      Number(jsonSafeGet<AuthTicketType>(context.cookies[CookiesConstants.AUTH_V2])?.t || context.cookies[CookiesConstants.TGT_TIMESTAMP])
          ? Number(jsonSafeGet<AuthTicketType>(context.cookies[CookiesConstants.AUTH_V2])?.t || context.cookies[CookiesConstants.TGT_TIMESTAMP])
          : null)
  );
  context.setData(
    "tgtTicket",
    jsonSafeGet<AuthTicketType>(context.cookies[CookiesConstants.AUTH_V2]).k ||
      context.cookies[CookiesConstants.TGT_TICKET] ||
      null
  );

  context.setData(
    "deviceUUID",
      jsonSafeGet<AuthTicketType>(context.cookies[CookiesConstants.AUTH_V2]).deviceUUID ||
    context.cookies[CookiesConstants.DEVICE_UUID] ||
      null
  );
  // if no device_id set in cookie & user is loggeout & the old cookie tracking_id is set
  if(!context.getData('deviceUUID') && !context.getData("member_id") && context.cookies[CookiesConstants.TRACKING_ID]){
    context.setData(
        "deviceUUID",
        context.cookies[CookiesConstants.TRACKING_ID]
    );
  }

  context.setData(
    "source",
    isDeviceMobile(context.req.customContext.userAgent) ? "mobile" : "desktop"
  );
  context.setData(
      "sessionId",
      jsonSafeGet<any>(context.cookies[CookiesConstants.SESSION]).id ||
      null
  );
  context.setData(
      "sessionStartedAt",
      jsonSafeGet<any>(context.cookies[CookiesConstants.SESSION]).startedAt ||
      null
  );

  setCookie(context, CookiesConstants.LOCALE, context.lang);
  setCookie(context, CookiesConstants.SOURCE, context.getData("source"));

}
